import { get as _get } from 'lodash';
import { prettifySize } from 'utils/prettify';
import * as _ from 'lodash';

// const selectButtonWidth = '64px';
const nameWidth = '205px';
const createdByWidth = '153px';
const whenWidth = '160px';
const downloadWidth = '46px';
/* eslint-disable */
const descriptionWidth = `calc(100% - ${nameWidth} - ${whenWidth} - ${createdByWidth} - ${downloadWidth})`;
/* eslint-enable */

export const columns: any = [
  {
    title: 'Report type',
    width: nameWidth,
    sortable: true,
    sortName: 'name',
    sort: 'desc',
    active: false,
    col: 'name',
    textEllipsis: true,
  },
  {
    title: 'Description',
    width: descriptionWidth,
    sortable: true,
    sortName: 'description',
    sort: 'desc',
    active: false,
    col: 'description',
    textEllipsis: true,
  },
  {
    title: 'Created by',
    width: createdByWidth,
    sortable: false,
    active: false,
    col: 'user.full_name',
    textEllipsis: true,
  },
  {
    title: 'When',
    width: whenWidth,
    sortable: true,
    sortName: 'created_at',
    sort: 'desc',
    active: false,
    col: 'created_at',
    type: 'date',
    textEllipsis: true,
  },
  {
    title: 'Download',
    width: downloadWidth,
    sortable: false,
    active: false,
    col: 'download',
    icon: 'download-icon',
    align: 'right',
    textEllipsis: true,
    config: {
      type: 'download-item',
      link: (row: any) => {
        return _.get(row, 'link');
      },
    },
  },
];
